export const getCurrentUserData = () => {
  try {
    const rawUser = localStorage.getItem("user");

    if (!rawUser) {
      return null;
    }

    return JSON.parse(rawUser);
  } catch (error) {
    return null;
  }
};

export const getCurrentUserEmployeeId = () => {
  const user = getCurrentUserData();
  return user?.employee_id || user?.employee?.id || null;
};
